<template>
	<div class="rebag">
		<TwoHeader></TwoHeader>
		<el-form ref="form" :rules="rules" :model="form" label-width="110px" :disabled="disable">
			<div class="bgcontent">
				<div class="box-card">
					<LeftNav></LeftNav>
					<div class="baoright">
						<div class="topone">
							<P class="tiship">个人信息填报（报名之前请务必把个人信息填写完整， <span class="biao">*</span>为必填项，没有请填无）</P>

							<div class="formzu">
								<el-form-item label="报考单位" class="quform" prop="companyNo">
									<el-select v-model="form.companyNo" placeholder="请选择报考单位" class="quselect"
										@change="selectdw" :popper-append-to-body="false">
										<el-option v-for=" (row,index) in regionOption" :label="row.companyName"
											:key="index" :value="row.id"></el-option>
									</el-select>
								</el-form-item>

							</div>
							<div class="formzus">
								<el-form-item label="报考岗位" class="quform" prop="positionId">
									<el-select v-model="form.positionId" placeholder="请选择报考岗位" class="quselect"
										@change="selectgw" :popper-append-to-body="false">
										<el-option v-for="(row,index) in gwoption" :label="row.postName" :key="index"
											:value="row.id"></el-option>
									</el-select>
								</el-form-item>
								<!--姓名-->
								<P class="formp"></P>
							</div>

							<div class="formzu">
								<el-form-item label="姓名" class="quformb" prop="registrationName">
									<el-input v-model.trim="form.registrationName" placeholder="请输入姓名" maxlength="20">
									</el-input>
								</el-form-item>
								<!--身份证-->
								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="身份证号" class="quformb" prop="idcard">
									<el-input v-model="form.idcard" @blur="IdCard(1)" placeholder="请输入15位或18位身份证号">
									</el-input>
								</el-form-item>
								<!--性别-->
								<P class="formp"></P>
							</div>
							<div class="formzu">
								<el-form-item label="性别" class="quform" prop="sex">
									<el-select v-model="form.sex" placeholder="请选择性别" disabled="false" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in sexoption" :key="index" :label="row.dictLabel"
											:value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								<!--出生年月日-->
								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="出生年月日" class="quformb" prop="birthday">
									<el-date-picker style="width: 100%" v-model="form.birthday" type="date"
										placeholder="选择日期" value-format='yyyy-MM-dd' disabled="false">

									</el-date-picker>
								</el-form-item>

								<P class="formp"></P>
							</div>

							<div class="formzu">
								<el-form-item label="家庭住址" class="quform" prop="postalAddress">
									<el-input v-model="form.postalAddress" placeholder="请输入家庭住址" maxlength="100">
									</el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>


							<div class="formzus">
								<el-form-item label="籍贯" class="quform" prop="nativePlace">
									<el-input v-model="form.nativePlace" placeholder="请输入籍贯" maxlength="20"></el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>

							<div class="formzu">
								<el-form-item label="联系电话" class="quformb" prop="phone">
									<el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
								</el-form-item>
								<!--民族-->
								<P class="formp"></P>
							</div>
							<!--							<div class="formzus">-->
							<!--								<el-form-item label="民族"  class="quform" prop="nationality">-->
							<!--									<el-select v-model="form.nationality" placeholder="请选择民族" class="quselect" :popper-append-to-body="false">-->
							<!--										<el-option label="汉族" value="汉族"></el-option>-->
							<!--										<el-option label="少数民族" value="少数民族"></el-option>-->
							<!--										<el-option label="其他" value="其他"></el-option>-->
							<!--									</el-select>-->
							<!--								</el-form-item>-->
							<!--								&lt;!&ndash;提示&ndash;&gt;-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->
							<div class="formzus">
								<el-form-item label="政治面貌" class="quform" prop="politicCountenance">
									<el-select v-model="form.politicCountenance" placeholder="请选择政治面貌" class="quselect"
										:popper-append-to-body="false">
										<el-option label="群众" value="群众"></el-option>
										<el-option label="中共党员" value="中共党员"></el-option>
										<el-option label="民主党派" value="民主党派"></el-option>
										<el-option label="共青团员" value="共青团员"></el-option>
									</el-select>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<div class="formzu">
								<el-form-item label="电子邮箱" class="quformb" prop="email">
									<el-input v-model.trim="form.email" placeholder="请输入电子邮箱" maxlength="50"></el-input>
								</el-form-item>
								<!--身份证-->
								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="参加工作时间" class="quformb" prop="participateWorkTime">
									<el-date-picker style="width: 100%" v-model="form.participateWorkTime" type="date"
										placeholder="选择日期" value-format='yyyy-MM-dd'>

									</el-date-picker>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<!--							<div class="formzus">-->
							<!--								<el-form-item label="婚姻状态"  class="quform" prop="marriage">-->
							<!--									<el-select v-model="form.marriage" placeholder="请选择婚姻状态" class="quselect" :popper-append-to-body="false">-->
							<!--										<el-option label="已婚" value="已婚"></el-option>-->
							<!--										<el-option label="未婚" value="未婚"></el-option>-->
							<!--									</el-select>-->
							<!--								</el-form-item>-->
							<!--								&lt;!&ndash;提示&ndash;&gt;-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->
							<div class="formzu">
								<el-form-item label="学历" class="quform" prop="educationOneName">
									<el-select v-model="form.educationOneName" placeholder="请选择学历" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in xuelioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="学位" class="quform" prop="studentStatusOneName">
									<el-select v-model="form.studentStatusOneName" placeholder="请选择学位" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in xueweioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>

								<P class="formp"></P>
							</div>

							<div class="formmiddleleft">
								<el-form-item label="毕业时间" class="quformb" prop="graduateTime">
									<el-date-picker style="width: 100%" v-model="form.graduateTime" type="date"
										value-format='yyyy-MM-dd' placeholder="选择日期">
									</el-date-picker>
								</el-form-item>

								<P class="formp"></P>
							</div>

							<div class="formmiddleleft" style="width: 23%;">
								<el-form-item label="所学专业" class="quformb" prop="major" label-width="93px">
									<el-input v-model="form.major" placeholder="请输入所学专业" maxlength="50"></el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<div class="formmiddleright">
								<el-form-item label="毕业院校" class="quformb" prop="graduateSchool">
									<el-input v-model="form.graduateSchool" placeholder="请输入毕业院校" maxlength="100">
									</el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<!-- <div class="formzu">
								<el-form-item label="第二学历" class="quform" prop="educationTwoName">
									<el-select v-model="form.educationTwoName" placeholder="请选择第二学历" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in xuelioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								
							<! 	<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="第二学位" class="quform" prop="studentStatusTwoName">
									<el-select v-model="form.studentStatusTwoName" placeholder="请选择第二学位"
										class="quselect" :popper-append-to-body="false">
										<el-option v-for="(row,index) in xueweioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								
								<P class="formp"></P>
							</div>
 -->
							<!-- <div class="formmiddleleft">
								<el-form-item label="毕业时间" class="quformb" prop="bak5">
									<el-date-picker style="width: 100%" v-model="form.params.bysj2" type="date"
										value-format='yyyy-MM-dd' placeholder="选择日期">
									</el-date-picker>
								</el-form-item>
								
								<P class="formp"></P>
							</div>

							<div class="formmiddleleft" style="width: 23%;">
								<el-form-item label="所学专业" class="quformb" prop="bak2" label-width="93px">
									<el-input v-model="form.params.zy2" placeholder="请输入所学专业" maxlength="50">
									</el-input>
								</el-form-item>
								
								<P class="formp"></P>
							</div>
							<div class="formmiddleright">
								<el-form-item label="毕业院校" class="quformb" prop="bak1">
									<el-input v-model="form.params.byyx2" placeholder="请输入最毕业院校" maxlength="100">
									</el-input>
								</el-form-item>
								
								<P class="formp"></P>
							</div>
							<div class="formzu">
								<el-form-item label="最高学历" class="quform" prop="educationHighestName">
									<el-select v-model="form.params.zgxl" placeholder="请选择最高学历" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in xuelioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								
								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="最高学位" class="quform" prop="studentStatusHighestName">
									<el-select v-model="form.params.zgxw" placeholder="请选择最高学位" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in xueweioption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								
								<P class="formp"></P>
							</div> -->
							<!--							<div class="formzu">-->
							<!--								<el-form-item label="考生身份"  class="quform" prop="identity">-->
							<!--									<el-select v-model="form.identity" placeholder="请选择考生身份" class="quselect" :popper-append-to-body="false">-->
							<!--                    <el-option label="应届" value="应届"></el-option>-->
							<!--                    <el-option label="往届" value="往届"></el-option>-->
							<!--&lt;!&ndash;                    <el-option  v-for="(row,index) in xueweioption"&ndash;&gt;-->
							<!--&lt;!&ndash;                                :key="index"&ndash;&gt;-->
							<!--&lt;!&ndash;                                :label="row.dictLabel"&ndash;&gt;-->
							<!--&lt;!&ndash;                                :value="row.dictValue"&ndash;&gt;-->
							<!--&lt;!&ndash;                    ></el-option>&ndash;&gt;-->
							<!--									</el-select>-->
							<!--								</el-form-item>-->
							<!--								&lt;!&ndash;提示&ndash;&gt;-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->

							<!-- 	<div class="formmiddleleft">
								<el-form-item label="毕业时间" class="quformb" prop="bak6">
									<el-date-picker style="width: 100%" v-model="form.params.bysj0" type="date"
										value-format='yyyy-MM-dd' placeholder="选择日期">
									</el-date-picker>
								</el-form-item>
								
								<P class="formp"></P>
							</div>

							<div class="formmiddleleft" style="width: 23%;">
								<el-form-item label="所学专业" class="quformb" prop="bak4" label-width="93px">
									<el-input v-model="form.params.zy0" placeholder="请输入所学专业" maxlength="50">
									</el-input>
								</el-form-item>
								
								<P class="formp"></P>
							</div>
							<div class="formmiddleright">
								<el-form-item label="毕业院校" class="quformb" prop="bak3">
									<el-input v-model="form.params.byyx0" placeholder="请输入最毕业院校" maxlength="100">
									</el-input>
								</el-form-item>
								
								<P class="formp"></P>
							</div> -->
							<!--            <div class="formzu">-->
							<!--              <el-form-item label="健康状况"  class="quform" prop="health">-->
							<!--                <el-select v-model="form.health" placeholder="请选择健康状况" class="quselect" :popper-append-to-body="false">-->
							<!--                  <el-option label="良好" value="良好"></el-option>-->
							<!--                  <el-option label="一般" value="一般"></el-option>-->
							<!--                  <el-option label="较差" value="较差"></el-option>-->
							<!--                  <el-option label="残疾" value="残疾"></el-option>-->
							<!--                </el-select>-->
							<!--              </el-form-item>-->
							<!--              &lt;!&ndash;提示&ndash;&gt;-->
							<!--              <P class="formp"></P>-->
							<!--            </div>-->
							<!--            <div class="formzu">-->
							<!--              <el-form-item label="生源地"  class="quform" prop="householdRegister">-->
							<!--                <el-input v-model="form.householdRegister" placeholder="请输入生源地" maxlength="100"></el-input>-->
							<!--              </el-form-item>-->
							<!--              &lt;!&ndash;提示&ndash;&gt;-->
							<!--              <P class="formp"></P>-->
							<!--            </div>-->
						</div>
						<div class="formzu">
							<el-form-item label="现工作单位" class="quformb">
								<el-input v-model="form.workUnit" placeholder="请输入现工作单位" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzus">
							<el-form-item label="研究方向" class="quformb">
								<el-input v-model="form.transfer" placeholder="请输入研究方向" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzu zgzg">
							<el-form-item label="最高专业技术资格证专业名称" class="quformb" required>
								<el-input v-model="form.params.zgzgzzymc" placeholder="请输入最高专业技术资格证专业名称" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzus">
							<el-form-item label="执业范围" class="quformb" required>
								<el-input v-model="form.params.zyfw" placeholder="请输入执业范围" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>

						<div class="formzu zgzg">
							<el-form-item label="现最高专业技术资格" class="quformb" style="line-height: 20px;" required>
								<el-input v-model="form.params.zgzgz" placeholder="请输入现最高专业技术资格" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzus">
							<el-form-item label="取得时间" class="quform" required>
								<el-date-picker style="width: 100%" v-model="form.params.zgzgzsj" type="date"
									value-format='yyyy-MM-dd' placeholder="选择日期">
								</el-date-picker>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzu">
							<el-form-item label="执业资格" class="quformb"  prop='vocationalQualification'>
								<el-input v-model="form.vocationalQualification" placeholder="请输入执业资格" maxlength="50">
								</el-input>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzus">
							<el-form-item label="取得时间" class="quform" required>
								<el-date-picker style="width: 100%" v-model="form.params.zyzgsj" type="date"
									value-format='yyyy-MM-dd' placeholder="选择日期">
								</el-date-picker>
							</el-form-item>

							<P class="formp"></P>
						</div>
						<div class="formzu">
							<el-form-item label="是否应届毕业生" class="quformb" label-width="120px">
								<el-radio-group v-model="form.jingxiaoFlag" @change="tuiyiflagchage">
									<el-radio label="是">是</el-radio>
									<el-radio label="否">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<P class="formp"></P>
						</div>

						<!-- <div class="formzus">
							<el-form-item label="执业资格及时间" class="quformb" prop="vocationalQualification">
								<el-input v-model="form.vocationalQualification" placeholder="请输入执业职格及取得时间"
									maxlength="100"></el-input>
							</el-form-item>
							<P class="formp"></P>
						</div> -->
						<!-- 	<div class="formzus">
							<el-form-item label="技术职称" class="quformb" prop="vocationalName">
								<el-input v-model="form.vocationalName" placeholder="请输入技术职称" maxlength="100">
								</el-input>
							</el-form-item>
							<P class="formp"></P>
						</div> -->
						<!-- <div class="formzu">
							<el-form-item label="学信网验证码" class="quformb" prop="majorCertificate">
								<el-input v-model="form.majorCertificate" placeholder="请输入学信网验证码" maxlength="100">
								</el-input>
							</el-form-item>
							<P class="formp"></P>
						</div> -->
						<div class="topone" style="padding-bottom: 40px;">
							<P class="tiship"><span style="color: red;">家庭成员至少填写两项</span>、请从<span style="color: red;">父母、兄弟姐妹、配偶及子女</span>中填写（如无工作单位填写 XX 社区居民/XX村务农）</P>
							<div class="formallline">
								<div class="familymembers">
									<div style="width: 15% ;line-height: 50px;">家庭成员</div>
									<div class="familyitems" style="justify-content: left"
										v-if="familyMembers.length==0">
										<el-button type="primary" icon="el-icon-plus" circle @click="additem"
											style="width: 40px;height: 40px;"></el-button>
									</div>
									<div class="persons">
										<div class="familyitems" v-for="(oneitem,i) in familyMembers " :key="i">
											<el-input class="item" v-model="oneitem.relationship" placeholder="请输入成员关系"
												maxlength="20"></el-input>
											<el-input class="item" v-model="oneitem.name" placeholder="请输入成员姓名"
												maxlength="20"></el-input>
											<el-input class="item" v-model="oneitem.age" placeholder="请输入年龄"
												maxlength="20"></el-input>
											<el-input class="item" v-model="oneitem.workplace" placeholder="请输入现工作单位"
												maxlength="50"></el-input>
											<el-input class="item" v-model="oneitem.idcard" placeholder="请输入职务"
												maxlength="20"></el-input>

											<el-button class="item iconbtn" type="primary" icon="el-icon-plus" circle
												@click="additem"></el-button>
											<el-button class="item iconbtn" type="primary" icon="el-icon-minus" circle
												@click="delitem(i)"></el-button>
										</div>
									</div>

								</div>

								<P class="formp"></P>
							</div>
						</div>
						<div class="topone">

							<P class="tiship">简历必须填写一项（简历填写:学习、工作、规培经历;从大学填起）</P>
							<!--            <div class="formzu">-->
							<!--              <el-form-item label="是否退役人员"  class="quformb" prop="tuiyiFlag" >-->
							<!--                <el-radio-group v-model="form.tuiyiFlag" @change="tuiyiflagchage">-->
							<!--                  <el-radio label="是">是</el-radio>-->
							<!--                  <el-radio label="否">否</el-radio>-->
							<!--                </el-radio-group>-->
							<!--              </el-form-item>-->
							<!--              <P class="formp"></P>-->
							<!--            </div>-->
							<!--            <div class="formzus">-->
							<!--              <el-form-item label="退役时间" class="quformb" prop="tuiyiTime" >-->
							<!--                <el-date-picker-->
							<!--                    style="width: 100%"-->
							<!--                    v-model="form.tuiyiTime"-->
							<!--                    type="date"-->
							<!--                    value-format='yyyy-MM-dd'-->
							<!--                    placeholder="选择日期"-->
							<!--                    :disabled="!tysjdiable"-->
							<!--                >-->
							<!--                </el-date-picker>-->
							<!--              </el-form-item>-->
							<!--              <P class="formp"></P>-->
							<!--            </div>-->
							<!--            <div class="formzu">-->
							<!--              <el-form-item label="报考岗位条件"  class="quformb" prop="otherReq">-->
							<!--                <el-input v-model="form.otherReq" placeholder="岗位表中的【其他要求】" maxlength="200"></el-input>-->
							<!--              </el-form-item>-->
							<!--              <P class="formp"></P>-->
							<!--            </div>-->

							<!--							<div class="formzus">-->
							<!--								<el-form-item label="基层工作年限"  class="quformb"  prop="baseWorkExperience" >-->
							<!--									<el-input v-model="form.baseWorkExperience" placeholder="请填写基层工作年限" maxlength="50"></el-input>-->
							<!--								</el-form-item>-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->
							<!--							<div class="formzu">-->
							<!--								<el-form-item label="服务基层项目"  class="quform" prop="baseService">-->
							<!--									<el-select v-model="form.baseService" placeholder="请选择服务基层项目" class="quselect" :popper-append-to-body="false">-->
							<!--                    <el-option label="无" value="无"></el-option>-->
							<!--										<el-option label="选聘高校毕业生到村任职工作" value="选聘高校毕业生到村任职工作"></el-option>-->
							<!--										<el-option label="大学生退役士兵服役五年" value="大学生退役士兵服役五年"></el-option>-->
							<!--										<el-option label="农村义务阶段学校教师特设岗位计划" value="农村义务阶段学校教师特设岗位计划"></el-option>-->
							<!--										<el-option label="三支一扶计划" value="三支一扶计划"></el-option>-->
							<!--										<el-option label="大学生志愿服务西部计划" value="大学生志愿服务西部计划"></el-option>-->
							<!--									</el-select>-->
							<!--								</el-form-item>-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->
							<!--							<div class="formzus">-->
							<!--								<el-form-item label="工作单位"  class="quformb" prop="workUnit">-->
							<!--									<el-input v-model="form.workUnit" placeholder="请输入工作单位" maxlength="100"></el-input>-->
							<!--								</el-form-item>-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->
							<!--							<div class="formzu">-->
							<!--								<el-form-item label="参加工作时间" class="quformb" prop="participateWorkTime" >-->
							<!--                  <el-date-picker-->
							<!--                      style="width: 100%"-->
							<!--                      v-model="form.participateWorkTime"-->
							<!--                      type="date"-->
							<!--                      value-format='yyyy-MM-dd'-->
							<!--                      placeholder="选择日期">-->
							<!--                  </el-date-picker>-->
							<!--								</el-form-item>-->
							<!--								<P class="formp"></P>-->
							<!--							</div>-->



							<!-- <div class="formallline" style="margin-bottom: 22px;">
								<el-form-item label="学习工作经历" class="quformb" prop="studyWorkExperience">
									<el-input type="textarea" style="z-index: 100" placeholder="学习工作经历（从高中开始填写）"
										v-model="form.studyWorkExperience" maxlength="150" rows="4" show-word-limit>
									</el-input>
								</el-form-item>
								<P class="formp"></P>
							</div> -->


							<div class="formallline">
								<div class="familymembers jianli1">
									<div style="width: 12% ;line-height: 50px;">简历</div>
									<div class="familyitems" style="justify-content: left" v-if="jianli.length==0">
										<el-button type="primary" icon="el-icon-plus" circle @click="additem2"
											style="width: 40px;height: 40px;"></el-button>
									</div>
									<div class="persons" style="width: 100%;">
										<div class="familyitems jianli" v-for="(oneitem,i) in jianli " :key="i">
											<el-input class="item" v-model="oneitem.timerange" placeholder="请输入起止时间"
												maxlength="20"></el-input>


											<el-input class="item" v-model="oneitem.jingli"
												placeholder="请输入学习、工作经历(从大学填起)" maxlength="20"></el-input>
											<el-input class="item" v-model="oneitem.job" placeholder="请输入专业或职位"
												maxlength="20"></el-input>


											<el-button class="item iconbtn" type="primary" icon="el-icon-plus" circle
												@click="additem2"></el-button>
											<el-button class="item iconbtn" type="primary" icon="el-icon-minus" circle
												@click="delitem2(i)"></el-button>
										</div>
									</div>

								</div>

								<P class="formp"></P>
							</div>

							<div class="formallline" style="margin-top: 42px;">
								<el-form-item label="获奖及科研情况" label-width="113px" class="quformb" prop="reward">
									<el-input type="textarea" style="z-index: 100" placeholder="请填写获奖及科研情况"
										v-model="form.reward" maxlength="150" rows="4" show-word-limit>
									</el-input>
								</el-form-item>
								<P class="formp"></P>
							</div>
							<div class="formallline" style="margin-top: 22px;">
								<el-form-item label="备注" class="quformb" prop="remark">
									<el-input type="textarea" style="z-index: 100" placeholder="" v-model="form.remark"
										maxlength="150" rows="4" show-word-limit>
									</el-input>
								</el-form-item>
								<P class="formp"></P>
							</div>

						</div>
						<div class="topone" v-if="$store.state.firstdo==1" style="margin-top:20px;">
							<P class="tiship">登录信息（ <span class="biao">*</span>为必填项，请使用半角字母数字）</P>

							<div class="formzu">
								<el-form-item label="登录密码" class="quformb" prop="password">
									<el-input v-model.trim="form.password" type="password" placeholder="8-20位数字字母组合">
									</el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="确认密码" class="quformb" prop="checkword">
									<el-input v-model.trim="form.checkword" placeholder="8-20位数字字母组合" type="password">
									</el-input>
								</el-form-item>

								<P class="formp"></P>
							</div>
							<div class="formzu">
								<el-form-item label="密码保护问题" class="quform" prop="forgetQuestion">
									<el-select v-model="form.forgetQuestion" placeholder="请选择密码保护问题" class="quselect"
										:popper-append-to-body="false">
										<el-option v-for="(row,index) in questionoption" :key="index"
											:label="row.dictLabel" :value="row.dictLabel"></el-option>
									</el-select>
								</el-form-item>
								<P class="formp"></P>
							</div>
							<div class="formzus">
								<el-form-item label="密码保护答案" class="quform" prop="forgetAnswer">
									<el-input v-model.trim="form.forgetAnswer" placeholder="请输入问题答案" maxlength="20">
									</el-input>
								</el-form-item>
								<P class="formp"></P>
							</div>

						</div>
						<div class="savebut">
							<button class="quxiao" :disabled="disable">取消</button>
							<button class="saver" :class="{'buutondisable':disable}" type="button"
								@click="formsubmit('form')" :disabled="disable"> <span
									v-if="$store.state.firstdo==1">提交</span> <span
									v-if="$store.state.firstdo==0">修改</span> </button>
						</div>

					</div>
				</div>
			</div>
		</el-form>
		<TowFooTer></TowFooTer>
	</div>
</template>

<script>
	import TwoHeader from '../components/common/twoheader.vue'
	import LeftNav from '../components/common/leftnav.vue'
	import TowFooTer from '../components/common/towfooter.vue'
	import {
		companyList,
		positionList,
		firstSignUp,
		dictdataconfig,
		examineeInfo,
		updateExamineeInfo,
		examDetail
	} from '@/api/api.js'
	import {
		mapState,
		mapMutations
	} from 'vuex'
	import {
		Loading
	} from 'element-ui';
	import $ from "jquery";
	export default {
		name: "tianbaoxinxi",
		components: {
			TwoHeader,
			LeftNav,
			TowFooTer
		},
		data() {
			const validatepwd = (rule, value, callback) => {
				if (value !== this.form.password && value !== '') {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			const idCardValidity = (rule, code, callback) => {
				var city = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外 "
				};
				var tip = ""
				var pass = true

				if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
					tip = "身份证号格式错误"
					pass = false;
				} else if (!city[code.substr(0, 2)]) {
					tip = "地址编码错误"
					pass = false
				} else {
					// 18位身份证需要验证最后一位校验位
					if (code.length === 18) {
						code = code.split('')
						// ∑(ai×Wi)(mod 11)
						// 加权因子
						var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
						// 校验位
						var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
						var sum = 0
						var ai = 0
						var wi = 0
						for (var i = 0; i < 17; i++) {
							ai = code[i]
							wi = factor[i]
							sum += ai * wi
						}
						// var last = parity[sum % 11];
						if (parity[sum % 11] != code[17]) {
							tip = "校验位错误"
							pass = false
						}
					}
				}
				if (!pass) {
					callback(new Error(tip))
				} else {
					callback()
				}
				// if (!pass) alert(tip)
				// return pass
			}
			return {
				form: {
					params: {
						zyfw: '',
						gpzsbh: '',
						zyzgsj: '',
						zgzgzzymc: '',
						zgzgz: '',
						zgzgzsj: ''
					},
					companyNo: "",
					companyName: "",
					positionId: "",
					postName: "",
					registrationName: '',
					idcard: '',
					sex: '',
					birthday: '',
					nationality: '',
					phone: '',
					politicCountenance: '',
					marriage: '',
					educationOneName: '',
					studentStatusOneName: '',
					identity: '',
					graduateTime: '',
					graduateSchool: '',
					major: '',
					baseWorkExperience: '',
					baseService: '',
					workUnit: '',
					otherReq: '',
					danweitime: '',
					majorCertificate: '',
					vocationalQualification: '',
					vocationalName: '',
					remark: '',
					familyMembers: [],
					jianli: [],
					password: '',
					checkword: '',
					participateWorkTime: '',
					forgetQuestion: '',
					forgetAnswer: '',
					studyWorkExperience: '',
					examinationId: 0,
					nativePlace: '',
					householdRegister: '',
					jingxiaoFlag: '是',
					tuiyiTime: "",
					tuiyiFlag: '',
					postalAddress: '',
					reward: "",
					health: "",
					educationTwoName: '',
					educationHighestName: '',
					studentStatusTwoName: '',
					studentStatusHighestName: '',
					bak6: '',
					bak5: '',
					bak4: '',
					bak3: '',
					bak2: '',
					bak1: '',
				},
				familyMembers: [{
						"relationship": "",
						"name": "",
						"age": "",
						"idcard": "",
						"workplace": ""
					},
					{
						"relationship": "",
						"name": "",
						"age": "",
						"idcard": "",
						"workplace": ""
					}
				],
				jianli: [{
						"timerange": "",
						"jingli": "",
						"job": ""
					},
					{
						"timerange": "",
						"jingli": "",
						"job": ""
					}
				],
				regionOption: [],
				examinationId: 0,
				gwoption: [],
				xuelioption: [],
				xueweioption: [],
				sexoption: [],
				questionoption: [],
				disable: true,
				rules: {
					companyNo: [{
						required: true,
						message: '请选择报考单位',
						trigger: ['change', 'blur']
					}],
					positionId: [{
						required: true,
						message: '请选择报考岗位',
						trigger: ['change', 'blur']
					}],
					registrationName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					zyfw: [{
						required: true,
						message: '请输入执业范围',
						trigger: 'blur'
					}],
					vocationalQualification: [{
						required: true,
						message: '请输入执业资格',
						trigger: 'blur'
					}],
					idcard: [{
							required: true,
							message: '请输入身份证号',
							trigger: 'blur'
						},
						{
							validator: idCardValidity,
							message: '请输入正确的身份证号',
							trigger: 'blur'
						}
					],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: ['change', 'blur']
					}],
					birthday: [{
						required: true,
						message: '请输入出生日期',
						trigger: 'blur'
					}],
					nationality: [{
						required: true,
						message: '请选择民族',
						trigger: ['change', 'blur']
					}],
					politicCountenance: [{
						required: true,
						message: '请选择政治面貌',
						trigger: ['change', 'blur']
					}],
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
							message: "请输入合法手机号",
							trigger: "blur"
						}
					],
					marriage: [{
						required: true,
						message: '请选择婚姻状况',
						trigger: ['change', 'blur']
					}],
					educationOneName: [{
						required: true,
						message: '请选择学历',
						trigger: ['change', 'blur']
					}],
					studentStatusOneName: [{
						required: true,
						message: '请选择学位',
						trigger: ['change', 'blur']
					}],
					identity: [{
						required: true,
						message: '请选择考生身份',
						trigger: ['change', 'blur']
					}],
					graduateTime: [{
						required: true,
						message: '请输入毕业时间',
						trigger: 'blur'
					}],
					graduateSchool: [{
						required: true,
						message: '请输入毕业院校',
						trigger: 'blur'
					}],
					major: [{
						required: true,
						message: '请输入专业',
						trigger: 'blur'
					}],
					householdRegister: [{
						required: true,
						message: '请输入生源地',
						trigger: 'blur'
					}],
					majorCertificate: [{
						required: true,
						message: '请输入学信网验证码',
						trigger: 'blur'
					}],
					// baseWorkExperience: [{ required: true, message:'请输入基层工作年限', trigger: 'blur'}],
					// workUnit: [{ required: true, message:'请输入工作单位', trigger: 'blur'}],
					nativePlace: [{
						required: true,
						message: '请输入户籍所在地',
						trigger: 'blur'
					}],
					// participateWorkTime: [{ required: true, message:'请输入工作时间', trigger: 'blur'}],
					// otherReq: [{ required: true, message:'请输入报考岗位条件', trigger: 'blur'}],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							// 正则不能含有两边的引号
							pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]+\S{7,12}$/,
							message: '需同时含有字母和数字，长度在8-12之间',
							trigger: ['change', 'blur'],
						}
					],
					email: [{
							required: true,
							message: '请输入电子邮箱',
							trigger: 'blur'
						},
						{
							// 正则不能含有两边的引号
							pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
							message: '请输入合法的电子邮箱',
							trigger: ['change', 'blur'],
						}
					],
					checkword: [{
						required: true,
						message: '请输入确认密码',
						trigger: 'blur'
					}, {
						validator: validatepwd,
						trigger: 'blur'
					}],
					forgetQuestion: [{
						required: true,
						message: '请选择密保问题',
						trigger: ['change', 'blur']
					}],
					forgetAnswer: [{
						required: true,
						message: '请输入答案',
						trigger: 'blur'
					}, {
						min: 1,
						max: 20,
						message: '长度在 1 到 20个字符',
					}],
					studyWorkExperience: [{
						required: true,
						message: '请填写学习工作经历',
						trigger: 'blur'
					}],
					familyMembers: [{
						required: true,
						message: '请填写家庭成员',
						trigger: 'blur'
					}],
					postalAddress: [{
						required: true,
						message: '请填写家庭住址',
						trigger: 'blur'
					}],
					tuiyiFlag: [{
						required: true,
						message: '请选择是否退役人员',
						trigger: 'blur'
					}],
				},
				tysjdiable: false,
				examinfo: {}
			}

		},


		created() {
			let servetime = new Date($.ajax({
				type: "HEAD",
				async: false,
				cache: false
			}).getResponseHeader("Date"));
			this.form.examinationId = this.examid;
			this.examinationId = this.$route.query.id;
			companyList({
				"examinationId": this.examid
			}).then(res => {
				this.regionOption = res.data.data;
			})
			dictdataconfig({
				"objType": 'education'
			}).then(res => {
				this.xuelioption = res.data.data;
			})
			dictdataconfig({
				"objType": 'student_status'
			}).then(res => {
				this.xueweioption = res.data.data;
			})
			dictdataconfig({
				"objType": 'sys_user_sex'
			}).then(res => {
				this.sexoption = res.data.data;
			})
			dictdataconfig({
				"objType": 'question'
			}).then(res => {
				this.questionoption = res.data.data;
			})
			if (this.$store.state.firstdo == 0) {
				examineeInfo({
					'examinationId': this.$store.state.examid
				}, this.$store.state.token).then(res => {
					console.log(res)
					let userinfo = res.data.data[0];
					// console.log("JSON.parse(res.data.data[0].familyMembers):"+JSON.parse(res.data.data[0].familyMembers))
					userinfo.familyMembers = JSON.parse(res.data.data[0].familyMembers)
					if (userinfo.params.jianli) {
						userinfo.params.jianli = JSON.parse(res.data.data[0].params.jianli)
					}
					this.$store.commit('updateUserexaminfo', userinfo);
					this.form = res.data.data[0];
					if (this.form.companyNo != "") {
						positionList({
							"examinationId": this.examinationId,
							"companyId": this.form.companyNo
						}).then(res => {
							this.gwoption = res.data.data;
						})
					}
					this.familyMembers = res.data.data[0].familyMembers;
					if (res.data.data[0].params.jianli) {
						this.jianli = res.data.data[0].params.jianli;
					}
					if ((this.$store.state.userexaminfo.checked == -1 || this.$store.state.userexaminfo.checked ==
							3)) {
						// console.log("this.examinfo.signUpEndDate:"+this.examinfo.signUpEndDate)
						// if(Date.parse(servetime)>Date.parse(this.examinfo.signUpEndDate.replace(/-/g,"/")) ){
						if (Date.parse(servetime) > Date.parse(this.examinfo.signUpEndDate)) {
							this.$confirm("本次考试报名已经结束,信息已经不能修改！", '温馨提示', {
								showCancelButton: false,
								confirmButtonText: '我知道了',
								type: 'warning'
							}).then(() => {
								return false;
							})
							return false;
						}
						this.disable = false

					} else if (this.$store.state.userexaminfo.checked == 5) {
						this.disable = false
					}
				})
			} else if (this.$store.state.firstdo == 1) {
				this.disable = false
			}
			// console.log("this.form.companyNo:"+this.form.companyNo)
			examDetail({
				"id": this.examid
			}).then(res => {
				this.examinfo = res.data.data;
			})

		},
		updated() {
			// console.log("this.examinfo:"+JSON.stringify(this.examinfo));
			examDetail({
				"id": this.examid
			}).then(res => {
				this.examinfo = res.data.data;

			})
		},
		computed: {
			...mapState({
				examid: 'examid'
			})

		},
		methods: {
			...mapMutations(['updateToken', 'modifyfirstdo', 'modifyshow', 'updateUserexaminfo']),
			tuiyiflagchage(value) {
				// console.log(value)
				if (value == "是") {
					this.tysjdiable = true
				} else if (value == "否") {
					this.tysjdiable = false
				}
			},
			IdCard(num) {
				let UUserCard = this.form.idcard;
				if (num == 1) {
					//获取出生日期
					let birth = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(
						12, 14);
					this.form.birthday = birth;
					//获取性别
					if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
						//男
						this.form.sex = "男";
					} else {
						//女
						this.form.sex = "女";
					}
				}
				if (num == 2) {
					//获取年龄
					var myDate = new Date();
					var month = myDate.getMonth() + 1;
					var day = myDate.getDate();
					var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
					if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(
							12, 14) <= day) {
						age++;
					}
					return age;
				}
			},
			additem() {
				if (this.familyMembers.length <= 4) {
					this.familyMembers.push({
						"relationship": "",
						"name": "",
						"age": "",
						"idcard": "",
						"workplace": ""
					})
				}

			},
			additem2() {
				if (this.jianli.length <= 4) {
					this.jianli.push({
						"timerange": "",
						"jingli": "",
						"job": ""
					})
				}

			},
			delitem(i) {
				// console.log("删除："+i);
				// console.log("删除前："+JSON.stringify(this.form.familyMembers));
				this.familyMembers.splice(i, 1);
				// console.log("删除后："+JSON.stringify(this.form.familyMembers));
			},
			delitem2(i) {
				// console.log("删除："+i);
				// console.log("删除前："+JSON.stringify(this.form.familyMembers));
				this.jianli.splice(i, 1);
				// console.log("删除后："+JSON.stringify(this.form.familyMembers));
			},
			formsubmit(formname) {
				let servetime = new Date($.ajax({
					type: "HEAD",
					async: false,
					cache: false
				}).getResponseHeader("Date"));
				if (Date.parse(servetime) > Date.parse(this.examinfo.signUpEndDate.replace(/-/g, "/")) && this.$store.state
					.userexaminfo.checked != 5) {

					this.$confirm("本次考试报名已经结束，无法完成本次操作！", '温馨提示', {
						showCancelButton: false,
						confirmButtonText: '我知道了',
						type: 'warning'
					})
					return false;

				}
				// if (this.form.vocationalQualification.length == 0) {
				// 	this.$message({
				// 		showClose: true,
				// 		message: "请填写执业资格",
				// 		type: 'error'
				// 	});
				// 	return false
				// }
				// if (this.form.params.zyzgsj.length == 0) {
				// 	this.$message({
				// 		showClose: true,
				// 		message: "请选择执业资格取得时间",
				// 		type: 'error'
				// 	});
				// 	return false
				// }
				if (this.form.params.zgzgzzymc.length == 0) {
					this.$message({
						showClose: true,
						message: "请填写最高专业技术资格证专业名称",
						type: 'error'
					});
					return false
				}
				if (this.form.params.zgzgz.length == 0) {
					this.$message({
						showClose: true,
						message: "请填写现最高专业技术资格",
						type: 'error'
					});
					return false
				}
				if (this.form.params.zgzgzsj.length == 0) {
					this.$message({
						showClose: true,
						message: "请选择现最高专业技术资格取得时间",
						type: 'error'
					});
					return false
				}
				if (this.form.params.zyzgsj.length == 0) {
					this.$message({
						showClose: true,
						message: "请选择执业资格取得时间",
						type: 'error'
					});
					return false
				}
				if (this.form.params.zyfw.length == 0) {
					this.$message({
						showClose: true,
						message: "请填写执业范围",
						type: 'error'
					});
					return false
				}
				if (this.jianli[0].timerange.length >= 1 &&
					this.jianli[0].jingli.length >= 1 &&
					this.jianli[0].job.length >= 1) {
					console.log("222")
				} else {
					this.$message({
						showClose: true,
						message: "简历填写不完成",
						type: 'error'
					});
					return false;
				}
				if (
					this.familyMembers[0].relationship.length >= 1 &&
					this.familyMembers[0].name.length >= 1 &&
					this.familyMembers[0].workplace.length >= 1 &&
					this.familyMembers[0].idcard.length >= 1
				) {
					console.log("2222");
				} else {

					this.$message({
						showClose: true,
						message: "社会关系填写不完整",
						type: 'error'
					});
					return false;
				}
				if (
					this.familyMembers[1].relationship.length >= 1 &&
					this.familyMembers[1].name.length >= 1 &&
					this.familyMembers[1].workplace.length >= 1 &&
					this.familyMembers[1].idcard.length >= 1
				) {
					console.log("2222");
				} else {
				
					this.$message({
						showClose: true,
						message: "社会关系填写不完整",
						type: 'error'
					});
					return false;
				}
				this.$refs[formname].validate(valid => {
					if (valid) {
						let loadingInstance1 = Loading.service({
							fullscreen: true,
							text: "报名信息提交中，请稍后…"
						});
						this.disable = true;
						this.form.familyMembers = JSON.stringify(this.familyMembers);
						this.form.params.jianli = JSON.stringify(this.jianli);
						if (this.$store.state.firstdo == 1) {
							firstSignUp({
								"examineeInfo": this.form,
								"userLogin": {
									"idCard": this.form.idcard,
									"pwd": this.form.password,
									"forgetQuestion": this.form.forgetQuestion,
									"forgetAnswer": this.form.forgetAnswer
								}
							}).then(res => {
								this.disable = false
								loadingInstance1.close()
								if (res.data.code == 0) {
									// this.$message({
									//   showClose: true,
									//   message: "报名成功！",
									//   type: 'success'
									// });
									this.updateToken(res.data.data.token);
									this.modifyfirstdo(0);
									this.modifyshow(2);
									this.updateUserexaminfo(res.data.data.examineeInfo);

									this.$confirm("恭喜您，提交成功！请牢记报名序号：" + res.data.data.examineeInfo
										.signUpNo + "，以后登录使用。", '温馨提示', {
											showCancelButton: false,
											confirmButtonText: '我知道了',
											type: 'success'
										}).then(() => {
										this.$router.push({
											path: '/photo'
										})
									})
									// this.$store.commit('updateToken',res.data.data.token);
									// this.$store.commit('modifyfirstdo',0);
									// this.$store.commit('modifyshow',2);
									// this.$store.commit('updateUserexaminfo',res.data.data.examineeInfo);


								} else {
									this.$message({
										showClose: true,
										message: res.data.msg,
										type: 'error'
									});
								}

							})
						} else if (this.$store.state.firstdo == 0) {

							delete this.form.examinationId;
							updateExamineeInfo(this.form, this.$store.state.token).then(res => {
								loadingInstance1.close()
								this.disable = false
								if (res.data.code == 0) {
									this.$message({
										showClose: true,
										message: '修改成功！',
										type: 'success'
									});
									this.$store.commit('modifyshow', 3);
									this.$router.push({
										path: '/status'
									})
								} else {
									this.$message({
										showClose: true,
										message: res.data.msg,
										type: 'error'
									});
								}
							})
						}

					} else {
						return false;
					}
				})
			},
			selectdw(e) {
				this.form.positionId = ""
				this.form.postName = ""
				let obj = {};
				this.gwoption = [];
				obj = this.regionOption.find((item) => {
					return item.id == e
				});

				this.form.companyName = obj.companyName;
				positionList({
					"examinationId": this.examinationId,
					"companyId": e
				}).then(res => {
					this.gwoption = res.data.data;
				})
			},
			selectgw(e) {
				let obj = {};
				obj = this.gwoption.find((item) => {
					// return item.postCode==e
					return item.id == e
				});
				// console.log("e"+e)
				// console.log("this.regionOption.find"+JSON.stringify(obj))
				this.form.postName = obj.companyName
			},
			onSubmit() {
				// console.log('submit!');
			}
		}
	}
</script>

<style scoped="">
	.zgzg>>>label {
		line-height: 20px !important;
	}

	.rebag {
		background: url('../assets/denglu.png');
		background-size: cover;
	}

	.bright {
		float: right;
	}

	.brightp {
		line-height: 130px;
		color: #FFFFFF !important;
		font-size: 16px;
		margin-left: 20px;
		list-style: none;
	}

	.brightp i {
		font-size: 20px;
	}

	.bgcontent {
		margin-top: 40px;
	}

	.el-card {
		border: none;
	}

	.box-card {
		margin: 0 auto;
		width: 1200px;
		margin: 0 auto;
		height: auto;
		overflow: hidden;
		margin-bottom: 50px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		background-color: #ECF4FF;
	}

	.baoimeg {
		width: 180px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		display: block;
		height: 64px;
		line-height: 64px;
		color: #ffffff;
	}

	.baoright {
		float: left;
		width: 979px;
		background-color: #ffffff;
		padding: 20px;
		padding-bottom: 50px;
	}

	.tiship {
		text-align: left;
		width: 100%;
		line-height: 42px;
		margin-top: -10px;
		border-bottom: 1px solid #D2D2D2;
		font-size: 14px;
		margin-bottom: 25px;
	}

	.formzu {
		width: 48%;
		float: left;
		height: 60px;
	}

	.formmiddleleft {
		width: 25%;
		float: left;
		height: 60px;
	}

	.formmiddle {
		width: 33%;
		height: 60px;
	}

	.formmiddleright {
		width: 48%;
		float: right;
		height: 60px;
	}

	.formzus {
		width: 48%;
		float: right;
		height: 60px;
	}

	.formallline {
		width: 96%;
		float: left;
		/*height: 100px;*/
		margin-top: 10px;
	}

	.quform {
		width: 100%;
	}

	.quformb {
		width: 100%;
	}

	.quselect {
		width: 100%;
	}

	.formp {
		text-align: left;
		margin-left: 110px;
		margin-top: -22px;
		color: #FE272D;
		font-size: 12px;
	}

	.biao {
		color: #FE272D;
		font-size: 16px;

	}

	.topone {
		display: block;
		min-height: 100px;
		float: left;
		margin-bottom: 10px;

	}

	.savebut {
		margin-top: 40px;
		width: 100%;
		float: left;
	}

	.quxiao {
		border: 1px solid #0099FF;
		color: #0099FF;
		background-color: #ffffff;
		margin-right: 50px;
		width: 100px;
		line-height: 32px;
		border-radius: 20px;
		cursor: pointer;
	}

	.saver {
		border: 1px solid #0099FF;
		color: #ffffff;
		background-color: #0099FF;
		margin-right: 30px;
		width: 100px;
		line-height: 32px;
		border-radius: 20px;
		cursor: pointer;
	}

	.buutondisable {
		background-color: #ccc;
		border: 1px solid #aaa;
	}

	.familymembers {
		display: flex;
		justify-content: space-around;
	}

	.persons {
		display: flex;
		flex-direction: column;
	}

	.familyitems {
		width: 100%;
		display: flex;
		justify-content: space-around;
	}

	.familyitems .item {
		margin-left: 10px;
		margin-top: 10px;
		width: 22%;
	}

	.jianli .item {
		margin-left: 10px;
		margin-top: 10px;
		width: 33%;
	}

	.jianli1 {
		display: flex;
		justify-content: space-between;
	}

	.iconbtn {
		width: 40px !important;
		height: 40px !important;
	}

	.el-select-dropdown {
		position: absolute !important;
		left: 0 !important;
		top: 30px !important;
	}
</style>